import React from 'react';
import { useParams } from 'react-router-dom';

import ToggleOption from '@/components/common/ToggleOption/ToggleOption';
import useGetContractDetailsFromCache from '@/hooks/contract/useGetContractDetailsFromCache.hook';
import CustomToggleTitleComponent from './components/CustomToggleTitleComponent';
import useToggleHidingContractLines from './hooks/useToggleHidingContractLines';

export default function HideContractLinesInInvoiceContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const contract = useGetContractDetailsFromCache(contractId);
  const { toggleHidingContractLines } = useToggleHidingContractLines(contractId);

  return (
    <>
      <ToggleOption
        id="hide-contract-lines"
        isEnable={Boolean(contract?.displaySettings.hide)}
        onChange={() => toggleHidingContractLines(!Boolean(contract?.displaySettings.hide))}
        title={(
          <CustomToggleTitleComponent
            title="Hide Contract Lines"
            displaySettings={contract?.displaySettings}
          />
        )}
      />
    </>
  );
}
